import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import Sheet from 'components/utils/Sheet'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import { triplePointsRoute } from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeover.constants'
import LineLuxuryEscapesMonogramIcon from 'LuxKit/Icons/line/LineLuxuryEscapesMonogramIcon'

const pillWrapperStyles = `
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

const ClickablePillWrapper = styled(Clickable)`
  ${pillWrapperStyles}
`

const PillWrapper = styled.div`
  ${pillWrapperStyles}
`

const PillPalette = styled(Sheet)`
  display: inline-flex;
`

function TriplePointTakeoverCampaignPill() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()
  const { pathname } = useLocation()
  const isOnTriplePointsPage = !!matchLocaleAwarePath(pathname, { path: `/:regionCode${triplePointsRoute}`, exact: true })
  const pillContent = <PillPalette paletteType="default">
    {/* BodyText parents can override nested SVG sizing, so keep the pill icon explicitly at 12px. */}
    <LoyaltyTierPill icon={<LineLuxuryEscapesMonogramIcon size={12} />} kind="primary" tier={tier}>
      {intl.formatMessage({
        id: '3irLpPPES2F5XYJLAZ6C',
        defaultMessage: 'Triple Points',
        description: 'Loyalty tier pill label for triple points promotion',
      })}
    </LoyaltyTierPill>
  </PillPalette>

  if (isOnTriplePointsPage) {
    // Don't use disabled Clickable as it shows pointer events.
    return <PillWrapper>
      {pillContent}
    </PillWrapper>
  }

  return <ClickablePillWrapper to={triplePointsRoute}>
    {pillContent}
  </ClickablePillWrapper>
}

export default TriplePointTakeoverCampaignPill
